import { apiUrl } from './api'

export const ANALYTICS_PREFERENCE = 'radiant_optional_analytics_v1'
let assessmentActive = false
export function setAssessmentAnalyticsState(value: boolean) {
  if (assessmentActive === value) return
  assessmentActive = value; window.dispatchEvent(new Event('radiant-assessment-state'))
}
const sessionKey = 'radiant_analytics_session_v1'
export function analyticsAllowed() { try { return localStorage.getItem(ANALYTICS_PREFERENCE) === 'allow' } catch { return false } }
export function setAnalyticsPreference(value: 'allow' | 'decline') {
  try { localStorage.setItem(ANALYTICS_PREFERENCE, value); if (value === 'decline') sessionStorage.removeItem(sessionKey) } catch { /* Analytics stays disabled when preferences cannot be saved. */ }
  window.dispatchEvent(new Event('radiant-analytics-preference'))
}
export function analyticsRoute() {
  const path = window.location.pathname
  if (path.startsWith('/manage') || path.startsWith('/feedback/') || path === '/peer-feedback') return null
  if (path === '/practice-lab') return 'practice'
  if (path === '/sample-report') return 'sample'
  if (path.startsWith('/reports')) {
    if (/\/reports\/.+/.test(path)) return 'reports'
    const tab = new URL(window.location.href).searchParams.get('view')
    return tab === 'practice' ? 'practice' : tab === 'account' ? 'account' : 'reports'
  }
  if (path === '/') return new URL(window.location.href).searchParams.has('code') || assessmentActive ? 'assessment' : 'landing'
  return 'unknown'
}
function source() {
  if (!document.referrer) return 'Direct'
  try {
    const host = new URL(document.referrer).hostname.toLowerCase()
    if (host === window.location.hostname || host === 'radianthealthinstitute.com' || host.endsWith('.radianthealthinstitute.com')) return 'Radiant'
    if (host === 'coachprep.trey.coach' || host === 'icf.trey.coach') return 'CoachPrep'
    if (host === 'trey.coach' || host.endsWith('.trey.coach')) return 'Trey Coach'
    if (host === 'coachprep.com' || host.endsWith('.coachprep.com')) return 'CoachPrep'
    if (/(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com|search\.yahoo\.com)$/.test(host)) return 'Search'
    if (/(^|\.)(facebook\.com|instagram\.com|linkedin\.com|t\.co|youtube\.com)$/.test(host)) return 'Social'
  } catch { /* Only a coarse referral category is sent. */ }
  return 'Other'
}
export function trackSiteEvent(name: 'page_view' | 'sample_open' | 'checkout_click' | 'sign_in_click') {
  if (!analyticsAllowed()) return
  const route = analyticsRoute()
  if (!route) return
  let sessionId: string
  try { sessionId = sessionStorage.getItem(sessionKey) || crypto.randomUUID(); sessionStorage.setItem(sessionKey, sessionId) } catch { return }
  const ua = navigator.userAgent
  const device = /iPad|Tablet/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) ? 'Tablet' : /Mobi|Android|iPhone/i.test(ua) ? 'Mobile' : 'Desktop'
  const browser = /Edg\//.test(ua) ? 'Edge' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome|CriOS/.test(ua) ? 'Chrome' : /Safari/.test(ua) ? 'Safari' : 'Other'
  const system = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) ? 'iOS' : /Android/.test(ua) ? 'Android' : /Windows/.test(ua) ? 'Windows' : /Mac/.test(ua) ? 'macOS' : /Linux/.test(ua) ? 'Linux' : 'Other'
  void fetch(apiUrl('/api/telemetry'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', keepalive: true,
    body: JSON.stringify({ consent: true, eventId: crypto.randomUUID(), sessionId, name, route, device, browser, system, source: source() }) }).catch(() => {})
}
